import React from 'react';
import { Facebook, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PHONE, PHONE_TEL, ADDRESS_LINE_1, ADDRESS_LINE_2, FACEBOOK_URL } from '../constants/business';
export function Footer() {
  const quickLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'In-Store',
    href: '/store-tour'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Events',
    href: '/events'
  }, {
    name: 'Contact',
    href: '/contact'
  }, {
    name: 'Brands',
    href: '/brands'
  }, {
    name: 'FAQ',
    href: '/faq'
  }];
  const selectionLinks = [{
    name: 'Store Tour',
    href: '/store-tour'
  }, {
    name: 'Firearms',
    href: '/firearms'
  }, {
    name: 'Ammunition',
    href: '/ammunition'
  }, {
    name: 'Optics',
    href: '/optics'
  }, {
    name: 'Thermal Optics',
    href: '/thermal-optics'
  }, {
    name: 'Reloading Supplies',
    href: '/reloading-supplies'
  }, {
    name: 'Safes & Accessories',
    href: '/safes-accessories'
  }, {
    name: 'Hunting Gear & Outdoor Gear',
    href: '/hunting-gear-blinds'
  }, {
    name: 'GunBroker Listings',
    href: '/gunbroker-listings'
  }];
  const serviceLinks = [{
    name: 'Gunsmithing',
    href: '/gunsmithing'
  }, {
    name: 'Suppressors & NFA Process',
    href: '/nfa-process'
  }, {
    name: 'Firearm Transfers',
    href: '/firearm-transfers'
  }, {
    name: 'Used Guns, Appraisals & Estates',
    href: '/used-guns-appraisals-estates'
  }, {
    name: 'Banquets & Fundraisers',
    href: '/banquets-fundraisers'
  }, {
    name: 'Minnesota Permit to Carry Classes',
    href: '/mn-permit-to-carry-classes'
  }];
  return <footer className="bg-brand-charcoal text-brand-cream pt-16 pb-24 lg:pb-8" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-54">
          {/* Column 1: Brand & Contact */}
          <div data-id="element-55">
            <div className="bg-brand-offwhite p-4 rounded-sm inline-block mb-6" data-id="element-56">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.ksportsllc.com/uploaded/images/Updated-logo.png?opt=w3" alt="Kjergaard Sports logo" className="h-12 w-auto" data-id="element-57" />
            </div>
            <p className="font-serif italic text-brand-leather mb-6 text-lg" data-id="element-58">
              Where the service and price are worth the trip.
            </p>
            <div className="space-y-3 text-brand-bone/80" data-id="element-59">
              <p className="flex items-start" data-id="element-60">
                <MapPin className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" data-id="element-61" />
                <span data-id="element-62">
                  {ADDRESS_LINE_1}
                  <br data-id="element-63" />
                  {ADDRESS_LINE_2}
                </span>
              </p>
              <p className="flex items-center" data-id="element-64">
                <Phone className="w-5 h-5 mr-3 flex-shrink-0" data-id="element-65" />
                <a href={PHONE_TEL} className="hover:text-brand-leather transition-colors" data-id="element-66">
                  {PHONE}
                </a>
              </p>
              <p className="flex items-center pt-2" data-id="element-67">
                <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="text-brand-bone hover:text-[#1877F2] transition-colors flex items-center" data-id="element-68">
                  <Facebook className="w-5 h-5 mr-3" data-id="element-69" />
                  Follow on Facebook
                </a>
              </p>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-70">
            <h3 className="text-lg font-serif text-brand-offwhite mb-6" data-id="element-71">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-72">
              {quickLinks.map(link => <li key={link.name} data-id="element-73">
                  <Link to={link.href} className="text-brand-bone/80 hover:text-brand-leather transition-colors" data-id="element-74">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Column 3: Selection */}
          <div data-id="element-75">
            <h3 className="text-lg font-serif text-brand-offwhite mb-6" data-id="element-76">
              In-Store Selection
            </h3>
            <ul className="space-y-3" data-id="element-77">
              {selectionLinks.map(link => <li key={link.name} data-id="element-78">
                  <Link to={link.href} className="text-brand-bone/80 hover:text-brand-leather transition-colors" data-id="element-79">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Column 4: Services */}
          <div data-id="element-80">
            <h3 className="text-lg font-serif text-brand-offwhite mb-6" data-id="element-81">
              Services &amp; Classes
            </h3>
            <ul className="space-y-3" data-id="element-82">
              {serviceLinks.map(link => <li key={link.name} data-id="element-83">
                  <Link to={link.href} className="text-brand-bone/80 hover:text-brand-leather transition-colors" data-id="element-84">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-brand-bone/20" data-id="element-85">
          <p className="text-brand-bone/60 text-sm mb-4" data-id="element-86">
            This website is for business information only. Kjergaard Sports does
            not conduct sales directly through this website. All firearm-related
            sales, transfers, and regulated services are handled in-store and in
            accordance with applicable laws.
          </p>
          <p className="text-brand-bone/40 text-sm" data-id="element-87">
            &copy; {new Date().getFullYear()} Kjergaard Sports. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}